import React from "react";
import { Button } from "usebeauty";
import { Close, Logo, ThumbsUp } from "@Icons";
import "./ComplatePage.scss";

const ComplatePage = () => {
  return (
    <div className="alchera-demo-complete">
      <div className="navigation">
        <i onClick={() => window.location.reload()}>
          <Close st={{ fontSize: "16px" }} />
        </i>
      </div>
      <div className="container">
        <div className="message">
          <h4>통합 데모 솔루션</h4>
          <p>체험이 모두 끝났습니다.</p>
          <p>감사합니다.</p>
        </div>

        <div className="content">
          <div className="button-conatiner">
            <div className="button inquiry">
              <a
                href="https://www.alchera.ai/contact-us?utm_source=demo&utm_medium=demo&utm_campaign=web-demo"
                rel="noreferrer"
                target="_blank">
                솔루션 문의하기
              </a>
            </div>
            <div className="button retry">
              <Button onClick={() => window.location.reload()}>다시 체험하기</Button>
            </div>
          </div>
          <div className="inquiry">
            <ThumbsUp st={{ fontSize: "inherit" }} />
            <span>궁금하신 점은 언제든지 문의해 주세요.</span>
          </div>
        </div>
      </div>

      <div className="logo">
        <Logo st={{ fontSize: "16px" }} />
      </div>
    </div>
  );
};

export default ComplatePage;
